// Services configuration for health monitoring
// This file centralizes the service names and endpoints for easier configuration

const serviceConfig = {
  // Microservices
  services: {
    auth: {
      id: 'auth-service',
      name: 'Authentication Service',
      // Use container name from K8s deployment
      endpoint: import.meta.env.VITE_AUTH_SERVICE_ENDPOINT || 'auth-service:8081',
    },
    admin: {
      id: 'admin-service',
      name: 'Admin Service',
      endpoint: import.meta.env.VITE_ADMIN_SERVICE_ENDPOINT || 'admin-service:8082',
    },
    student: {
      id: 'student-service',
      name: 'Student Service',
      endpoint: import.meta.env.VITE_STUDENT_SERVICE_ENDPOINT || 'student-service:8083',
    },
    core: {
      id: 'core-service',
      name: 'Core Service',
      endpoint: import.meta.env.VITE_CORE_SERVICE_ENDPOINT || 'core-service:8085',
    },
    apiGateway: {
      id: 'api-gateway',
      name: 'API Gateway',
      endpoint: import.meta.env.VITE_API_GATEWAY_ENDPOINT || 'api-gateway:8080',
    },
  },
  
  // Infrastructure
  infrastructure: {
    mongodb: {
      id: 'mongodb',
      name: 'MongoDB Database',
      endpoint: import.meta.env.VITE_MONGODB_ENDPOINT || 'mongodb:27017',
    },
    redis: {
      id: 'redis',
      name: 'Redis Cache',
      endpoint: import.meta.env.VITE_REDIS_ENDPOINT || 'redis:6379',
    },
    mailgun: {
      id: 'mailgun',
      name: 'Mailgun Email Service',
      endpoint: import.meta.env.VITE_MAILGUN_ENDPOINT || 'mailgun',
    },
  },
  
  // Get all services as array for easier iteration
  getAllServices() {
    return [
      ...Object.values(this.services),
      ...Object.values(this.infrastructure)
    ];
  },
  
  // Get service by ID
  getServiceById(id) {
    const allServices = this.getAllServices();
    return allServices.find(service => service.id === id);
  },
  
  // Get service name by ID
  getServiceNameById(id) {
    const service = this.getServiceById(id);
    return service ? service.name : id;
  }
};

export default serviceConfig;
